import DpitMultiStateBtn from './DpitMultiStateBtn';
import BulletsAnimation from '../../../../includes/assets/js/modules/BulletsAnimation';

export default class DpitMultiStateAnimBtn extends DpitMultiStateBtn {


	/**
	 * 
	 * @param {Function} onClickCB
	 * @param {object} statesOptions 
	 * {'default': { content: 'Default state label', isActive: true },
	 * 	'success': { content: 'Success message', isActive: true },
	 * 	'error': { content: 'Error message', isActive: true }}
	 * @param {string} initState
	 * @param {string} bemRootClass
	 * @param {Array|string} additionalClasses
	 * @param {string} id
	 * @param {string} htmlTag
	 */
	constructor(onClickCB, statesOptions = {}, initState = 'default', bemRootClass = 'dpit-admin-btn', additionalClasses = [], inactive = false, id = '', htmlTag = 'div') {
		super(onClickCB, statesOptions, initState, bemRootClass, additionalClasses, inactive, id, htmlTag);
		// Animation
		this.bulletsAnimation = new BulletsAnimation(this.element, bemRootClass + '__anim', 90, 12, 5, 3);
	}

	startAnimation(backward = false, loops = -1, loopsPassedCb = null) {
		this.isAnimated = true;
		this.bulletsAnimation.start(backward, loops, () => this.onAnimationEnded(loopsPassedCb));
		this.element.style.setProperty('pointer-events', 'none');
		this.element.style.setProperty('cursor', 'default');
		this.addStateClass('anim');
	}

	stopAnimation() {
		this.bulletsAnimation.stop();
		this.element.style.removeProperty('pointer-events');
		this.element.style.removeProperty('cursor');
		this.removeStateClass('anim');
		this.isAnimated = false;
	}

	onAnimationEnded(loopsPassedCb = null) {
		this.stopAnimation();
		if (loopsPassedCb) loopsPassedCb();
	}

	hideStateItems() {
		this.stateKeys.forEach(state => {
			const stateEl = this.stateOptions[state].element;
			if (stateEl) {
				stateEl.style.opacity = 0;
			}
		});
	}

	showStateItems() {
		this.stateKeys.forEach(state => {
			const stateEl = this.stateOptions[state].element;
			if (stateEl) {
				stateEl.style.opacity = '';
			}
		});
	}
}